import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import PortalTaskActions from '~common/components/portal-task/portal-task-actions'
import DefinitionSection from '~common/form/definition-section';
import {Definition} from '~common/lib/types';
import { APIError } from '~common/lib/types';

import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
// import {SummaryAction} from '~common/components/query-fulfillment/query-list';
// import {
//   Button,
// } from '@mui/material';
import {setValueAtPathWithOpts} from '~common/form/helper';

// Uncomment if you will be using the PortalUSerContext;
// import PortalUser from '~common/lib/portal-user-context';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: "#fff",
  },
  embeddedContainer: {
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    height: "100%",
    right: 0,
    backgroundColor: "#fff",
    zIndex: 1000
  },
  modalContent: {
    minHeight:300, 
    minWidth:"70%"
  },
  appbar: {
    top: 'auto',
    bottom: 0,
  },
  toolbar: {
        border: "0px solid #dedede",
        backgroundColor: "#111"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  action?: any;
  title?: string;
  items?: Array<any>;
  data?: any;
  // formSelector is the form that will be presented to the user if the summary action is selected.
  // Ignored if form is provided
  formSelector?: any;

  // The form to be used
  form?: Definition;

  // onFormComplete is called when the form is completed by the user.  
  // `done` is called with the action is complete to dismiss the modal and trigger and update of the results list automatically.
  onFormComplete?: (formData:any, cancelled: boolean, done:Function) => void;

  // onINitiateData is called when initiating the data for a path.
  onInitiateData?: Function;

  // allow one to override the props for the compelte button.  `label` will be used as the prop for the button text 
  formCompleteButtonProps?: any;

  // allow one to override the props for the cancel button.  `label` will be used as the prop for the button text 
  formCancelButtonProps?: any;

  // onChangeAtPath allows the consumer to subscribe to updates as they happen, rather than relying upon the onFormComplete
  onChangeAtPath?: Function;

  // policyMessages allows the top-level consumer to inject messages into the form.
  policyMessages?: any;

  // preventCollapse: prevent definiton section from rendering collapsable sections
  preventCollapse?: boolean;

  // Custom messages to be provided to the form
  customRenderers?: any;

  // Custom messages to be provided to the form
  customMessages?: any;

  // Grid Spacing is the spacing for the grid that will be honored in the form.  Will default to 8
  gridSpacing?: 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 

  // determines whether the form is embedded in another form
  embedded?: boolean

}

type State = {
  status: 'loading' | 'ready' | 'error';
  form?: Definition;
  data: any;
  error?: any;
};

class DefinitionFormController extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'ready',
      data: props.data || {},
      form: props.form
    };
  }

 componentDidMount() {
    this.handleProps(this.props);
    window.scrollTo(0,0)
  }

  UNSAFE_componentWillReceiveProps(newProps: any) {
    this.handleProps(newProps);
  }

  handleChangeAtPath = (path: string, value: any) => {
    let {data, err} = setValueAtPathWithOpts(path, this.state.data, value, {
      emptyAsNull: true
    });
    if (err) {
      const apiErr = new APIError();
      apiErr.message = err;
      this.setState({
        error: apiErr
      });
    } else {
      this.setState({
        data: data
      });
    }

    if (this.props.onChangeAtPath) {
      this.props.onChangeAtPath(path, value) 
    }

  };

  handleProps(props: any) {
    var {
      form,
      formSelector
    } = props;
    //var {currentPage, criteria} = this.state
    var newState: State = this.state;

    if(form){
      newState.form = form
      this.setState(newState)

    } else {

      this.setState({status:"loading"}, ()=>{
        request.get(
          '/api/form-definitions/select?selector=' + JSON.stringify(formSelector)
        )
        .then((response) => {

          // If provided an actual form, we will just use it
          newState.form = new Definition(new Definition(response.body));
          newState.status = "ready"
          this.setState(newState)

        })
        .catch((err) => {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = 'Error fetching data during initialization';
          apiErr.details = (err.response || {text: err.toString()}).text;
          this.setState({
            status: 'error',
            error: apiErr
          });
        });
      })
    }
  }

  handleAction = (action) => {

    var cancelled = true 
    if (action.key == "complete") {
      cancelled = false
    }
    if(this.props.onFormComplete) {
      this.props.onFormComplete(this.state.data, cancelled);
    }
  }



  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const { preventCollapse, policyMessages, customRenderers, customMessages, gridSpacing, definition, onFormComplete, embedded, multiFormCancelButtonProps, multiFormCompleteButtonProps } = this.props;
    const {status, data, form} = this.state;

    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView classes={
              {}
            } />
          </div>
        );

      default:

        var actions:Array<any>;
        if (onFormComplete) {
          actions = [
            {
              key: "cancel",
              action:"Cancel"
            },
            {
              key: "complete",
              action:"Complete",
              options: {
                buttonColor: "primary"
              }
            }
          ]
          if (definition) {
            if (multiFormCancelButtonProps && multiFormCancelButtonProps.label) {
              actions[0].action = multiFormCancelButtonProps.label
            }

            if (multiFormCompleteButtonProps && multiFormCompleteButtonProps.label) {
              actions[1].action = multiFormCompleteButtonProps.label
            }
          }
        }

        var cc = classes.container
        var position:string = undefined 
        if (embedded) {
          position = "fixed"
          cc = classes.embeddedContainer
        }

        return (
          <div className={cc}>
              <DefinitionSection
                data={data}
                definition={form}
                path={''}
                onChangeAtPath={this.handleChangeAtPath}
                policyMessages={policyMessages}
                gridSpacing={gridSpacing || 1}
                customRenderers={customRenderers}
                customMessages={customMessages}
                embedded={true}
                supressSectionStatusIcon={true}
                preventCollapse={preventCollapse}
              />
            { actions &&
              <PortalTaskActions 
                  disabled={false}
                  variant="minimal"
                  position={position}
                  actions={actions} 
                  handleAction={this.handleAction}    
              />
            }
          </div>
        )
    }
  }
}

export default withStyles(styles)(DefinitionFormController);




